import React, {
  useCallback,
  useRef,
  useState,
  useEffect,
  ChangeEvent,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Select, Input, Layout } from '../../../components';
import SelectType from '../../../components/Form/Select/select_type';
import { useToast } from '../../../hooks/toast';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import type { ParamsProps } from '../../../shared/interfaces/parameter';
import type { PerfilDataDTO } from '../../../shared/interfaces/perfil';
import type { ScreenData } from '../../../shared/interfaces/screen';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Container, FormContainer, FormFooter } from './styles';

const Editar: React.FC = () => {
  const formRef = useRef<FormHandles | null>(null);
  const history = useHistory();
  const { id } = useParams<ParamsProps>();
  const { addToast } = useToast();
  const [dataTable, setDataTable] = useState<SelectType[]>([]);
  const [data, setData] = useState<PerfilDataDTO>({
    id: '',
    nomePerfil: '',
    idTelasList: [],
  });
  let selectedScreens = useRef<number[] | null>(null);

  useEffect(() => {
    if (id !== undefined) {
      findPerfil(id);
    }
  }, [id]);

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get<ScreenData[]>(`/tela`);

      let screenValues: SelectType[] = response.data.map(
        (screen: ScreenData) => {
          return {
            value: screen.id,
            label: screen.titulo,
          };
        },
      );

      setDataTable(screenValues);
    } catch (e) {
      console.error(e);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  function updateValue(e: ChangeEvent<HTMLInputElement>) {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  }

  const handleSubmit = useCallback(
    async (perfil: PerfilDataDTO) => {
      perfil.idTelasList = selectedScreens.current;

      try {
        if (!perfil.idTelasList?.length) {
          const schemaSelect = Yup.object().shape({
            id: Yup.string().max(25, 'No máximo 25 caracteres'),
            nomePerfil: Yup.string()
              .max(200, 'No máximo 200 caracteres')
              .required('Este campo é obrigatório!'),
            select: Yup.string().required('Este campo é obrigatório!'),
          });
          await schemaSelect.validate(perfil, {
            abortEarly: false,
          });
        }
        const schema = Yup.object().shape({
          id: Yup.string().max(25, 'No máximo 25 caracteres'),
          nomePerfil: Yup.string()
            .max(40, 'No máximo 40 caracteres')
            .required('Este campo é obrigatório!'),
        });

        await schema.validate(perfil, {
          abortEarly: false,
        });

        if (id !== undefined) {
          await api.put(`/perfil/${id}`, perfil);
          addToast({
            type: 'success',
            title: 'Perfil alterado com sucesso!',
            description: 'As informações do Perfil foram alteradas.',
          });
        } else {
          await api.post('/perfil', perfil);
        }

        setTimeout(() => {
          history.push(RoutesPaths.listPerfil);
        }, 4000);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorMessages = getValidationErrors(err);
          formRef.current?.setErrors(errorMessages);
          return;
        } else {
          console.error(err);
          addToast({
            type: 'error',
            title: 'Perfil já cadastrado!',
            description:
              'As informações que foram inseridas, já estão presentes no sistema.',
          });
        }
      }
    },
    [addToast, history, id],
  );

  async function findPerfil(id: string) {
    const response = await api.get<PerfilDataDTO>(`/perfil/${id}`);

    setData({
      id: id,
      nomePerfil: response.data.nomePerfil,
      idTelasList: response.data.idTelasList,
    });

    selectedScreens.current = response.data.idTelasList;
  }

  function handleScreenChange(dataTable: any | null) {
    let screens: number[] = [];
    if (dataTable) {
      screens = dataTable.map((item: any) => item['value']);
    }

    const newData = data;
    newData.idTelasList = screens;

    selectedScreens.current = screens;
    setData(newData);
  }

  return (
    <>
      <Layout title="Editar Perfil" hideFloatingButton>
        <Container>
          <FormContainer>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Input
                type="text"
                label="Nome"
                name="nomePerfil"
                value={data.nomePerfil}
                onChange={(e: ChangeEvent<HTMLInputElement>) => updateValue(e)}
                loading={!data.nomePerfil ? true : false}
              ></Input>

              <Select
                name={'select'}
                options={dataTable}
                onChange={handleScreenChange}
                placeholder="Selecione"
                initialValues={data.idTelasList}
                label="Telas"
                loading={!dataTable.length ? true : false}
              />

              <FormFooter>
                <Button
                  variant="solid"
                  style={{ marginTop: '1rem' }}
                  type="submit"
                  disabled={!dataTable.length || !data.nomePerfil}
                >
                  Salvar
                </Button>
              </FormFooter>
            </Form>
          </FormContainer>
        </Container>
      </Layout>
    </>
  );
};

export default Editar;
